module.exports = __webpack_public_path__ + "media/images/input_state_icon/warning-98e3d49777d393e9eebdff62072de846.svg";